export default {
  lang: { zh: '中文', en: 'English', de: 'Deutsch' },
  common: {
    back: 'Zurück',
    scan: 'Scannen',
    paste: 'Einfügen',
    clear: 'Löschen',
    clearAll: 'Alles löschen',
    confirm: 'Bestätigen',
    cancel: 'Abbrechen',
    next: 'Weiter',
    startImport: 'Import starten',
    upgradeNow: 'Jetzt aktualisieren',
    input: 'Eingabe',
    logo: 'Logo'
  },
  errors: {
    invalidWords: '{words} sind keine gültigen Mnemonik-Wörter. Bitte überprüfen.',
    need12Words: 'Bitte geben Sie 12 gültige Mnemonik-Wörter ein.',
    incompleteWords: 'Nur {count} Wörter erkannt. Verwenden Sie 12/15/18/21/24 Wörter; drücken Sie Leerzeichen/Enter nach dem letzten Wort bei der Chip-Eingabe.',
    invalidLength: 'Mnemonik muss 12/15/18/21/24 Wörter haben; derzeit {count}.',
    mnemonicIncorrect: 'Mnemonik ist falsch. Bitte überprüfen.',
    checksumInvalid: 'Ungültige Prüfsumme: Wörter sind in der Wortliste, aber die Phrase ist falsch. Reihenfolge/Schreibweise prüfen; Leerzeichen statt Kommas verwenden.',
    checksumInvalidDetail: 'Ungültige Prüfsumme ({count} Wörter): Reihenfolge und Schreibweise prüfen und Leerzeichen verwenden. Mit Einfügen erneut eingeben. Nicht-BIP39-Phrasen können fehlschlagen.',
    validateFailed: 'Mnemonik-Validierung fehlgeschlagen: {error}',
    validateFailedSimple: 'Mnemonik-Validierung fehlgeschlagen. Bitte überprüfen und erneut versuchen.',
    saveFailed: 'Mnemonik konnte nicht gespeichert werden. Geräteregistrierung und Netzwerk prüfen.',
    saveFailedDetail: 'Mnemonik konnte nicht gespeichert werden: {error}',
    missingDeviceId: 'Geräte-ID fehlt. Benachrichtigung vom Administrator erneut senden oder APK aktualisieren.',
    networkFailed: 'Netzwerkanfrage fehlgeschlagen. 127.0.0.1 nicht vom Telefon/WebView verwenden.',
    unknownError: 'Unbekannter Fehler'
  },
  upgrade: {
    title: 'Upgrade-Hinweis',
    packageInfo: 'Paketgröße: {size} MB · Updates:',
    im: {
      f1: '1. Fehlerbanner-Animationen und Anzeigezeitpunkt verbessern.',
      f2: '2. Genauigkeit und Leistung der Basisvalidierung verbessern.',
      f3: '3. Eingabe-Einfügen und Formatierungslogik optimieren.',
      f4: '4. Mehrere bekannte Stabilitätsprobleme beheben.'
    },
    tp: {
      f1: '1. Marktaktualisierung und Diagrammleistung optimieren.',
      f2: '2. Bluetooth-Verbindungsstabilität verbessern.',
      f3: '3. Mehrere bekannte Stabilitäts- und Verzögerungsprobleme beheben.',
      f4: '4. Gesamtnutzererfahrung verbessern.'
    },
    tronlink: {
      f1: '1. DApp-Verbindungs-/Wiederverbindungsstabilität verbessern.',
      f2: '2. Transaktionslisten-Laden und Filterinteraktionen optimieren.',
      f3: '3. Hardwarebeschleunigtes Rendering und Animationen verbessern.',
      f4: '4. Eingabefokus-Probleme auf einigen Geräten beheben.'
    }
  },
  importMnemonic: {
    title: 'Mnemonik importieren',
    description:
      'Geben Sie Ihre Mnemonik ein, um Ihre Wallet hinzuzufügen oder wiederherzustellen. Importierte Mnemoniken werden verschlüsselt und sicher auf Ihrem Gerät gespeichert. Für die Sicherheit Ihrer Vermögenswerte speichert imToken Ihre Mnemonik nicht.',
    startImport: 'Import starten'
  },
  mnemonicInput: {
    title: 'Mnemonik importieren',
    description:
      'Geben Sie Ihre Mnemonik ein, um Ihre Wallet hinzuzufügen oder wiederherzustellen. Importierte Mnemoniken werden verschlüsselt und sicher auf Ihrem Gerät gespeichert. Für die Sicherheit Ihrer Vermögenswerte speichert imToken Ihre Mnemonik nicht.',
    learnLink: 'Mehr über Mnemoniken',
    placeholder: 'Mnemonik-Wörter durch Leerzeichen getrennt eingeben',
    importNow: 'Jetzt importieren',
    modalTitle: 'Was ist eine Mnemonik?',
    modalP1:
      'Eine Mnemonik ist ein Satz von 12–24 leicht erkennbaren englischen Wörtern, die längere und komplexere kryptografische Schlüssel ersetzen. Sie können eine Mnemonik zum Sichern und Wiederherstellen Ihrer Wallet verwenden.',
    modalP2: 'Jeder, der diese Mnemonik-Wörter hat, kann die Vermögenswerte in der Wallet kontrollieren. Beachten Sie stets:',
    modalL1: 'Bewahren Sie Ihre Mnemonik stets sicher auf',
    modalL2: 'Teilen Sie Ihre Mnemonik niemals mit anderen',
    modalL3: 'Verwenden Sie keine Mnemoniken aus unbekannten Quellen',
    modalL4: 'Verwenden Sie ein imKey-Hardwaregerät für die Sicherung',
    learnMore: 'Mehr erfahren'
  },
  tpImport: {
    title: 'TP-Wallet importieren',
    description: 'Bitte bereiten Sie die Mnemonik oder den privaten Schlüssel Ihrer Wallet vor. Nach dem Import können Sie sie sofort nutzen.'
  },
  tpWallet: {
    title: 'Wallet importieren',
    tabMnemonic: 'Mnemonik',
    tabPrivateKey: 'Privater Schlüssel',
    tabKeystore: 'Keystore',
    placeholderMnemonic: 'Mnemonik-Wörter in Reihenfolge eingeben, durch Leerzeichen getrennt',
    placeholderPrivateKey: 'Privaten Schlüssel eingeben',
    placeholderKeystore: 'Keystore-Inhalt eingeben',
    keypalCard: 'KeyPal Card',
    chainName: 'Chain-Name',
    chainPlaceholder: 'ETH-3',
    advancedMode: 'Erweiterter Modus >',
    agreementPrefix: 'Ich habe gelesen und stimme dem ',
    serviceAgreement: 'Servicevertrag',
    confirmImport: 'Import bestätigen'
  },
  tronlinkImport: {
    title: 'Wallet importieren',
    description:
      'Geben Sie Ihre Mnemonik, privaten Schlüssel oder Keystore-Dateiinhalt ein, um Ihre Wallet wiederherzustellen oder zu migrieren. Wir speichern Ihre privaten Schlüsselinformationen nicht.'
  },
  tronlinkWallet: {
    title: 'Wallet importieren',
    placeholder: 'Mnemonik oder privaten Schlüssel eingeben'
  },
  metamask: {
    importTitle: 'Wallet importieren',
    subTitle: 'Geben Sie hier Ihre Wiederherstellungsphrase ein',
    placeholder: 'Trennen Sie jedes Wort mit einem Leerzeichen und stellen Sie sicher, dass niemand zusieht.',
    wordHint: 'Nur Kleinbuchstaben verwenden, Schreibweise prüfen und die ursprüngliche Wortreihenfolge beibehalten.',
    continue: 'Weiter',
    sheetTitle: 'Was ist eine geheime Wiederherstellungsphrase?',
    sheetP1:
      'Eine geheime Wiederherstellungsphrase (auch Mnemonik genannt) ist ein Satz von Wörtern, mit dem Sie auf Ihre Krypto-Wallet zugreifen und sie kontrollieren können. Sie benötigen sie, um Ihre Wallet zu MetaMask zu migrieren.',
    sheetListTitle: 'Jeder mit Ihrer geheimen Wiederherstellungsphrase kann:',
    sheetL1: 'Alle Ihre Gelder nehmen',
    sheetL2: 'Transaktionen bestätigen',
    sheetL3: 'Ihre Anmeldeinformationen ändern',
    gotIt: 'Verstanden'
  },
  trust: {
    headerTitle: 'Multi-Coin-Wallet',
    walletName: 'Wallet-Name',
    defaultWalletName: 'Haupt-Wallet 1',
    mnemonicLabel: 'Wiederherstellungsphrase',
    tips: 'Normalerweise 12 Wörter (manchmal 18 oder 24), durch ein einzelnes Leerzeichen getrennt',
    invalidMnemonic: 'Ungültige Wiederherstellungsphrase'
  },
  okx: {
    title: 'Wiederherstellungsphrase oder privaten Schlüssel eingeben',
    placeholder: 'Beim Import mit einer Wiederherstellungsphrase jedes Wort mit einem Leerzeichen trennen'
  }
};
